import dayjs from 'dayjs';

type DateLike = Date | dayjs.Dayjs;
type AnyDateLike = DateLike | string;
type OptionalDateLike = AnyDateLike | null | undefined;

const ADULT_AGE_YEARS = 18;

export const parseDate = (value: OptionalDateLike): dayjs.Dayjs | null => {
  if (!value) {
    return null;
  }

  const parsed = dayjs(value);
  return parsed.isValid() ? parsed : null;
};

export const isValidDOB = (value: OptionalDateLike): boolean => {
  if (!value) {
    return false;
  }

  const dob = parseDate(value);
  if (!dob) {
    return false;
  }

  return !dob.isAfter(dayjs(), 'day');
};

export const getAgeInYears = (value: OptionalDateLike): number | null => {
  const dob = parseDate(value);

  if (!isValidDOB(dob)) {
    return null;
  }

  return dayjs().diff(dob, 'year');
};

export const isAdultDOB = (value: OptionalDateLike): boolean => {
  const ageInYears = getAgeInYears(value);

  if (ageInYears === null) {
    return false;
  }

  return ageInYears >= ADULT_AGE_YEARS;
};

export const isMinorDOB = (value: OptionalDateLike): boolean => {
  const ageInYears = getAgeInYears(value);

  if (ageInYears === null) {
    return false;
  }

  return ageInYears < ADULT_AGE_YEARS;
};
